import React from "react";
import { Container } from "@chakra-ui/react";
import ListRole  from "./components/ListRole";
export default function Role() {

    return (
        <Container maxW="xxl" mt={100}>
            <ListRole />
        </Container>
    );
}
